const EmailVerificationIcon = ({ size = 24 }) => {
  return (
    <img
      src={require("../../../assets/images/email-verification.svg").default}
      alt="email verification"
      width={size}
    />
  );
};

export default EmailVerificationIcon;
